import React, { forwardRef } from 'react'
import { getDensityUnit } from '../../../constants'
import './SlrPrintTemplate.scss'

const PACKING_TYPE_LABELS = {
	DG_UN_PACKAGING: 'DG UN Packaging',
	METAL_BOXES: 'Metal boxes',
	WOODEN_BOXES: 'Wooden boxes',
	PLYWOOD_BOXES: 'Plywood boxes',
	FIBRE_BOARD: 'Fibre board',
	PLASTIC_BOX: 'Plastic box',
	NO_PACKAGING: 'No packaging',
	ACFT_ENGINE_ON_STAND: 'Acft Engine on stand',
}

const getPackingTypeLabel = (packingType) => PACKING_TYPE_LABELS[packingType] || packingType || '--'

const getYesNo = (value) => (value === 'Y' || value === true ? 'Yes' : 'No')

const DIMENSION_UNIT_LABELS = { B: 'M', C: 'Cm', I: 'In', F: 'Ft' }

const getDimensionUnitLabel = (unit) => DIMENSION_UNIT_LABELS[unit] || unit || 'Cm'

const STATUS_BADGE_CLASSES = {
	N: 'slr-print-status-badge--new',
	P: 'slr-print-status-badge--pending',
	R: 'slr-print-status-badge--rejected',
	C: 'slr-print-status-badge--booked',
}

const getStatusBadgeConfig = (slrStatus, slrDisplayStatus) => ({
	className: STATUS_BADGE_CLASSES[slrStatus] || 'slr-print-status-badge--default',
	label: (slrDisplayStatus || '-').toUpperCase(),
})

const EtihadLogo = () => (
	<svg
		width='155'
		height='42'
		viewBox='0 0 120 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		className='slr-print-brand-svg'
		aria-label='Etihad Cargo'
		role='img'
	>
		<path d='M39.0005 31.8405C37.6302 31.8405 36.5567 31.431 35.7798 30.6118C35.0026 29.7928 34.6143 28.5914 34.6143 27.0075C34.6143 25.4781 35.0233 24.2902 35.8418 23.4438C36.6602 22.5977 37.6901 22.1745 38.9315 22.1745C40.1084 22.1745 40.9957 22.4008 41.5936 22.8533V24.8082C40.9957 24.0751 40.1957 23.7086 39.1936 23.7086C38.3199 23.7086 37.6464 23.9847 37.1729 24.5367C36.6992 25.0888 36.4625 25.8854 36.4625 26.926C36.4625 27.9849 36.6992 28.8131 37.1729 29.4104C37.6464 30.0077 38.3199 30.3064 39.1936 30.3064C40.2418 30.3064 41.0418 29.9806 41.5936 29.3289V31.0259C41.336 31.2703 40.975 31.4671 40.5108 31.6165C40.0464 31.7658 39.5429 31.8405 39.0005 31.8405Z' fill='#000'/>
		<path d='M44.1865 31.6233L47.9107 22.3918H49.1107L52.7934 31.6233H50.89L50.1451 29.7091H47.7038L47.1796 28.3923H49.6486L48.6693 25.8536L48.4072 25.0526L48.1451 25.8536L45.9382 31.6233H44.1865Z' fill='#000'/>
		<path d='M57.6488 27.3332H58.835C59.8648 27.3332 60.3799 26.727 60.3799 25.5141C60.3799 24.9621 60.2602 24.5413 60.0212 24.2515C59.782 23.962 59.382 23.8171 58.8212 23.8171H57.6488V27.3332ZM60.835 31.6232L58.6833 28.5958H57.6488V31.6232H55.8281V22.3918H58.835C59.9385 22.3918 60.7799 22.6383 61.3592 23.1315C61.9385 23.6249 62.2281 24.3601 62.2281 25.3376C62.2281 26.0526 62.0626 26.6748 61.7316 27.2043C61.4005 27.7337 60.9316 28.1162 60.3247 28.3514L62.8764 31.6232H60.835Z' fill='#000'/>
		<path d='M69.8692 31.8405C68.5083 31.8405 67.4255 31.4287 66.621 30.6051C65.8162 29.7816 65.4141 28.5823 65.4141 27.0075C65.4141 25.4781 65.8485 24.2902 66.7175 23.4438C67.5865 22.5977 68.6781 22.1745 69.9934 22.1745C71.152 22.1745 72.1311 22.4235 72.9313 22.9212V24.8761C72.1772 24.0978 71.2669 23.7086 70.2003 23.7086C69.2623 23.7086 68.538 23.9847 68.0277 24.5367C67.5173 25.0888 67.2623 25.8854 67.2623 26.926C67.2623 27.9849 67.5012 28.829 67.9794 29.4579C68.4576 30.087 69.1104 30.4014 69.9382 30.4014C70.4531 30.4014 70.8436 30.3471 71.1106 30.2385V27.6455H72.9313V31.0802C72.1402 31.5872 71.1197 31.8405 69.8692 31.8405Z' fill='#000'/>
		<path d='M80.8071 30.32C81.653 30.32 82.3241 30.0327 82.8211 29.4579C83.3174 28.8833 83.5657 28.0891 83.5657 27.0754C83.5657 25.9984 83.3198 25.1658 82.828 24.5774C82.3358 23.989 81.6623 23.695 80.8071 23.695C79.961 23.695 79.2898 23.9801 78.7933 24.5503C78.2967 25.1203 78.0485 25.9123 78.0485 26.926C78.0485 28.0032 78.2944 28.8379 78.7864 29.4308C79.2782 30.0236 79.9519 30.32 80.8071 30.32ZM80.8071 31.8405C79.4002 31.8405 78.2806 31.4219 77.4485 30.5845C76.616 29.7477 76.2002 28.5549 76.2002 27.0075C76.2002 26.2383 76.3312 25.5411 76.5933 24.9168C76.8554 24.2923 77.2047 23.7832 77.6416 23.3895C78.078 22.9957 78.5679 22.695 79.1105 22.4866C79.653 22.2787 80.2185 22.1745 80.8071 22.1745C82.2142 22.1745 83.3332 22.5932 84.1657 23.4303C84.9978 24.2675 85.4142 25.4597 85.4142 27.0075C85.4142 27.7768 85.283 28.4735 85.0209 29.0982C84.7588 29.7226 84.4093 30.2317 83.9724 30.6254C83.5358 31.0189 83.0461 31.3201 82.5034 31.528C81.9608 31.7363 81.3955 31.8405 80.8071 31.8405Z' fill='#000'/>
		<path d='M67.4841 12.5042L71.1481 8.63798V0.991337C71.1481 0.934707 71.2204 0.875748 71.2204 0.875748L71.7511 0.613932V0.173105H66.8376V0.606367L67.3426 0.923264C67.4872 1.00937 67.4995 1.06911 67.4995 1.11817V5.51206H57.6638L55.4441 8.28346L55.4435 1.13776L55.4577 0.999481C55.4622 0.993469 55.4955 0.962828 55.5741 0.922295L56.0398 0.635457L56.0886 0.609468V0.173105H51.1836V0.604815L51.6685 0.91473C51.7398 0.962828 51.7722 0.989785 51.783 0.989785C51.7844 0.989785 51.7856 0.989009 51.7862 0.988233L51.7875 14.1226L51.7619 14.2925C51.7418 14.3235 51.7046 14.359 51.6699 14.3815L51.1836 14.7029V15.1262H56.0886V14.6976L55.5767 14.3776C55.4975 14.3346 55.4608 14.309 55.448 14.309C55.4466 14.309 55.4455 14.3093 55.4447 14.3099L55.4441 8.28346L55.9741 8.44307L56.6545 8.0581C56.7775 7.98382 56.8855 7.93282 56.9627 7.91478C57.0039 7.90062 57.0849 7.88317 57.238 7.88317H67.4841V12.5042Z' fill='#000'/>
		<path d='M119.677 6.02033C119.102 4.22814 117.784 2.75788 115.76 1.64991C113.935 0.644912 111.347 0.156572 107.849 0.156572H94.4941V0.58324C94.4941 0.58324 95.0532 0.950366 95.0711 0.950366C95.0736 0.950366 95.0756 0.949591 95.0762 0.947264L95.0736 2.50595H107.828C110.405 2.50595 112.292 2.84457 113.436 3.50494C115.257 4.55124 116.145 5.90959 116.149 7.65679C116.149 8.53398 115.911 9.33592 115.441 10.0409C114.975 10.7414 114.26 11.3418 113.316 11.8251C112.081 12.4547 110.198 12.7739 107.722 12.7739H101.072V3.5829H97.4348L97.4368 14.132L97.4135 14.2878C97.3905 14.3159 97.3519 14.3533 97.3172 14.3853L96.8695 14.6638L96.8303 14.6914V15.1194H107.734C109.832 15.1194 111.482 15.0024 112.637 14.7715C114.221 14.4458 115.626 13.8795 116.814 13.0885C118.027 12.2863 118.894 11.357 119.393 10.3262C119.763 9.57233 119.951 8.73975 119.951 7.85112C119.951 7.21907 119.859 6.60331 119.677 6.02033Z' fill='#000'/>
		<path d='M71.7354 14.554C71.6286 14.5373 71.5681 14.515 71.5348 14.497L80.6881 5.12779L78.5719 2.90854L66.7275 15.0905H72.1792V14.5777H71.9888C71.8976 14.5777 71.8133 14.5655 71.7354 14.554Z' fill='#000'/>
		<path d='M79.5556 2.32863L81.8943 4.77227L84.3126 7.1678H80.2277L77.9883 9.4753L78.473 9.8017L79.0011 9.52087C79.0519 9.49993 79.1039 9.47937 79.1491 9.47568C79.1832 9.46987 79.3189 9.46793 79.5317 9.46793L86.5175 9.4689L91.3376 14.5391C91.337 14.5398 91.2643 14.6267 90.8456 14.6267H90.6584V15.1412H96.1089L81.6614 0.157866L79.5556 2.32863Z' fill='#000'/>
		<path d='M44.5361 0.606063L45.0236 0.916171C45.1369 0.992002 45.1941 1.06124 45.1941 1.12291L45.198 14.1093L45.1633 14.2765C45.1188 14.3147 45.068 14.3581 45.0321 14.3812L44.5361 14.6961V15.1313H49.4031V14.7008L48.9537 14.3888C48.8912 14.3467 48.8551 14.3182 48.8418 14.3182C48.8392 14.3182 48.8378 14.3191 48.8364 14.3207L48.8347 1.1423L48.8475 1.00209L48.958 0.901433L49.4031 0.607615V0.172996H44.5361V0.606063Z' fill='#000'/>
		<path d='M24.1249 12.2545L23.4849 12.616C23.3139 12.7195 23.2187 12.7523 23.2006 12.7601L12.303 12.7882C9.81376 12.7882 7.92095 12.4703 6.67701 11.8443C4.80016 10.8845 3.88607 9.51641 3.88233 7.66313C3.88233 6.82919 4.12667 6.03772 4.60706 5.31258C5.54814 3.94938 6.90164 3.02293 8.84213 2.66861C9.35544 2.57784 9.85061 2.55612 10.1771 2.55612H15.7905C16.1257 2.54177 16.0746 2.62148 16.0849 2.65658L16.0232 3.04369H16.4882L18.8918 0.184826H12.1885C10.6384 0.184826 9.42795 0.234474 8.59051 0.332607C8.14657 0.387105 7.72923 0.459831 7.31504 0.554861C6.21908 0.800776 5.14874 1.21173 4.13376 1.7761C2.49415 2.6911 1.31977 3.85474 0.64312 5.23578C0.263613 6.02318 0.0732675 6.90095 0.0772084 7.84485C0.0732675 10.2569 1.39248 12.1817 3.998 13.5655C5.17258 14.2008 6.49435 14.6401 7.92726 14.8719C8.99898 15.0441 10.4737 15.1313 12.3101 15.1313H22.4461L24.8614 12.2424H24.6638L24.1249 12.2545Z' fill='#000'/>
		<path d='M19.2889 8.65833L21.6495 5.75583H5.76123L4.16162 8.10443L18.4842 8.10405C18.7537 8.13294 18.8464 8.19811 18.856 8.24233L18.7975 8.65833H19.2889Z' fill='#000'/>
		<path d='M18.3062 2.90825L18.7584 3.06359L18.8226 3.07949L19.5129 2.73738C19.7026 2.61229 19.8924 2.5512 20.093 2.5512H28.8707L28.8738 14.1296L28.8352 14.2917C28.798 14.3359 28.7562 14.3644 28.7284 14.377L28.2275 14.7031V15.1315H33.1312V14.6959L32.6218 14.3908L32.4995 14.2797C32.4969 14.2523 32.4931 14.2087 32.4957 14.155V2.5512L40.2821 2.55062C40.5812 2.58611 40.6198 2.6538 40.6187 2.66097V3.06999H41.0559L43.4711 0.17312H20.5219L18.3062 2.90825Z' fill='#000'/>
	</svg>
)

const SlrPrintTemplate = forwardRef(({ bookingDetails, slrDisplayStatus, isEnterpriseOrGsa }, ref) => {
	if (!bookingDetails?.slrReferenceNumber) return null

	const hasDimensionDetails = Array.isArray(bookingDetails.dimensionDetails) && bookingDetails.dimensionDetails.length > 0
	const hasRoutingDetails = Array.isArray(bookingDetails.transitAirports) && bookingDetails.transitAirports.length > 0
	const hasSkyPalletDetails = !!bookingDetails?.skyPalletDetails
	const hasUldDetails = Array.isArray(bookingDetails.uldDetails) && bookingDetails.uldDetails.length > 0
	const hasDangerousGoods = Array.isArray(bookingDetails.additionalCommodityDetails?.dangerousGoods) && bookingDetails.additionalCommodityDetails.dangerousGoods.length > 0

	const statusBadgeConfig = getStatusBadgeConfig(bookingDetails.slrStatus, slrDisplayStatus)

	return (
		<div className='slr-print-template' ref={ref}>
			<div className='slr-print-document'>
				<div className='slr-print-letterhead'>
					<div className='slr-print-brand'>
						<EtihadLogo />
					</div>
					<div className='slr-print-heading'>
						<div className='slr-print-doc-title'>SPECIAL LOAD REQUEST (SLR)</div>
					</div>
				</div>

				<div className='slr-print-ref-row'>
					<div className='slr-print-field'>
						<span className='slr-print-label'>REFERENCE NUMBER</span>
						<span className='slr-print-value slr-print-ref-number'>{bookingDetails.slrReferenceNumber}</span>
					</div>
					<div className='slr-print-field'>
						<span className='slr-print-label'>STATUS</span>
						<div className={`slr-print-status-badge ${statusBadgeConfig.className}`}>
							{statusBadgeConfig.label}
						</div>
					</div>
				</div>

				{bookingDetails.slrStatus === 'R' && bookingDetails.rejectionReason && (
					<div className='slr-print-rejection-row'>
						<span className='slr-print-label'>REJECTION REASON</span>
						<span className='slr-print-rejection-value'>{bookingDetails.rejectionReason}</span>
					</div>
				)}

				<div className='slr-print-section'>
					<div className='slr-print-section-title'>APPLICATION DETAILS</div>
					<div className='slr-print-grid slr-print-grid--app'>
						<div className='slr-print-field'>
							<span className='slr-print-label'>ORIGIN - DESTINATION</span>
							<span className='slr-print-value'>
								{bookingDetails.origin && bookingDetails.destination
									? `${bookingDetails.origin} - ${bookingDetails.destination}`
									: '--'}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>SUBMITTED DATE</span>
							<span className='slr-print-value'>
								{bookingDetails.submittedDate || '--'}{Boolean(bookingDetails.submittedTime) && ` (${bookingDetails.submittedTime})`}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>SHIPPING DATE</span>
							<span className='slr-print-value'>{bookingDetails.shippingDate || '--'}</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>CUSTOMER CODE / NAME</span>
							<span className='slr-print-value'>
								{bookingDetails.agentCode && bookingDetails.agentName
									? `${bookingDetails.agentCode} - ${bookingDetails.agentName}`
									: bookingDetails.agentCode || bookingDetails.agentName || '--'}
							</span>
						</div>
					</div>
				</div>

				<div className='slr-print-section'>
					<div className='slr-print-section-title'>CARGO DETAILS</div>
					<div className='slr-print-grid'>
						<div className='slr-print-field'>
							<span className='slr-print-label'>PRODUCT</span>
							<span className='slr-print-value'>{bookingDetails.cargoDetails?.product || '--'}</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>COMMODITY</span>
							<span className='slr-print-value'>{bookingDetails.cargoDetails?.commodity || '--'}</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>SCC</span>
							<span className='slr-print-value'>
								{bookingDetails.cargoDetails?.sccCodes?.filter(Boolean).join(', ') || '--'}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>GROSS WEIGHT</span>
							<span className='slr-print-value'>
								{bookingDetails.cargoDetails?.grossWeight != null && bookingDetails.cargoDetails.grossWeight !== ''
									? `${bookingDetails.cargoDetails.grossWeight} ${bookingDetails.cargoDetails?.weightUnit || ''}`
									: '--'}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>AWB NUMBER</span>
							<span className='slr-print-value'>{bookingDetails.cargoDetails?.awbNumber || '--'}</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>VOLUME</span>
							<span className='slr-print-value'>
								{bookingDetails.cargoDetails?.volume != null && bookingDetails.cargoDetails.volume !== ''
									? `${bookingDetails.cargoDetails.volume} ${bookingDetails.cargoDetails?.volumeUnit || ''}`
									: '--'}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>DENSITY</span>
							<span className='slr-print-value'>
								{bookingDetails.cargoDetails?.density != null && bookingDetails.cargoDetails.density !== ''
									? `${bookingDetails.cargoDetails.density} ${getDensityUnit(bookingDetails.cargoDetails?.weightUnit, bookingDetails.cargoDetails?.volumeUnit)}`
									: '--'}
							</span>
						</div>
						<div className='slr-print-field'>
							<span className='slr-print-label'>SHIPMENT DESCRIPTION</span>
							<span className='slr-print-value'>{bookingDetails.cargoDetails?.shipmentDescription || '--'}</span>
						</div>
					</div>
				</div>

				{hasDangerousGoods && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>DANGEROUS GOODS (UN ID SUMMARY)</div>
						<div className='slr-print-grid'>
							<div className='slr-print-field slr-print-field--full'>
								<span className='slr-print-value'>
									{bookingDetails.additionalCommodityDetails.dangerousGoods.map((dg) => dg.unid).filter(Boolean).join(', ') || '--'}
								</span>
							</div>
						</div>
					</div>
				)}

				{hasDimensionDetails && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>DIMENSION DETAILS</div>
						<table className='slr-print-tabular slr-print-tabular--dimensions' aria-label='Dimension Details'>
							<thead className='slr-print-tabular-header'>
								<tr className='slr-print-tabular-row'>
									<th scope='col' className='slr-print-tabular-cell'>PIECES</th>
									<th scope='col' className='slr-print-tabular-cell'>
										LENGTH x WIDTH x HEIGHT
										<br />
										({getDimensionUnitLabel(bookingDetails.dimensionDetails[0]?.dimensionUnit)})
									</th>
									<th scope='col' className='slr-print-tabular-cell'>WEIGHT/PIECE</th>
									<th scope='col' className='slr-print-tabular-cell'>PACKING TYPE</th>
									<th scope='col' className='slr-print-tabular-cell'>STACKABLE</th>
									<th scope='col' className='slr-print-tabular-cell'>TILTABLE</th>
									<th scope='col' className='slr-print-tabular-cell'>
										CRANE
										<br />
										LIFTABLE
									</th>
									<th scope='col' className='slr-print-tabular-cell'>
										FORK
										<br />
										LIFTABLE
									</th>
									<th scope='col' className='slr-print-tabular-cell'>FRAGILE</th>
								</tr>
							</thead>
							<tbody>
							{bookingDetails.dimensionDetails.map((dim, index) => (
								<tr className='slr-print-tabular-row' key={index}>
									<td className='slr-print-tabular-cell'>{dim.pieces ?? '--'}</td>
									<td className='slr-print-tabular-cell'>{dim.length ?? '--'} x {dim.width ?? '--'} x {dim.height ?? '--'}</td>
									<td className='slr-print-tabular-cell'>{dim.weightPerPiece ?? '--'} {dim.weightUnit || ''}</td>
									<td className='slr-print-tabular-cell'>{getPackingTypeLabel(dim.packingType)}</td>
									<td className='slr-print-tabular-cell'>{getYesNo(dim.stackable ?? true)}</td>
									<td className='slr-print-tabular-cell'>{getYesNo(dim.tiltable)}</td>
									<td className='slr-print-tabular-cell'>{getYesNo(dim.craneLiftable)}</td>
									<td className='slr-print-tabular-cell'>{getYesNo(dim.forkLiftable)}</td>
									<td className='slr-print-tabular-cell'>{getYesNo(dim.fragile)}</td>
								</tr>
							))}
							</tbody>
						</table>
					</div>
				)}

				{hasUldDetails && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>ULD DETAILS</div>
						<table className='slr-print-tabular slr-print-tabular--ulds' aria-label='ULD Details'>
							<thead className='slr-print-tabular-header'>
								<tr className='slr-print-tabular-row'>
									<th scope='col' className='slr-print-tabular-cell'>ULD TYPE</th>
									<th scope='col' className='slr-print-tabular-cell'>NO. OF UNITS</th>
									<th scope='col' className='slr-print-tabular-cell'>WEIGHT</th>
								</tr>
							</thead>
							<tbody>
							{bookingDetails.uldDetails.map((uld, index) => (
								<tr className='slr-print-tabular-row' key={index}>
									<td className='slr-print-tabular-cell'>{uld.uldType || '--'}</td>
									<td className='slr-print-tabular-cell'>{uld.numberOfUnits ?? '--'}</td>
									<td className='slr-print-tabular-cell'>{uld.weight ?? '--'} {uld.weightUnit || ''}</td>
								</tr>
							))}
							</tbody>
						</table>
					</div>
				)}

				{hasRoutingDetails && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>ROUTING DETAILS</div>
						<table className='slr-print-tabular slr-print-tabular--routing' aria-label='Routing Details'>
							<thead className='slr-print-tabular-header'>
								<tr className='slr-print-tabular-row'>
									<th scope='col' className='slr-print-tabular-cell'>TRANSIT AIRPORT</th>
									<th scope='col' className='slr-print-tabular-cell'>CARRIER CODE</th>
								</tr>
							</thead>
							<tbody>
							{bookingDetails.transitAirports.map((transit, index) => (
								<tr className='slr-print-tabular-row' key={index}>
									<td className='slr-print-tabular-cell'>{transit.airportCode || '--'}</td>
									<td className='slr-print-tabular-cell'>{transit.carrierCode || '--'}</td>
								</tr>
							))}
							</tbody>
						</table>
					</div>
				)}

				{bookingDetails.submittedBy && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>SUBMITTED BY</div>
						<table className='slr-print-tabular slr-print-tabular--submitted' aria-label='Submitted By'>
							<tbody>
								<tr className='slr-print-tabular-row'>
									<th scope='row' className='slr-print-sub-label-cell'>NAME</th>
									<td className='slr-print-sub-value-cell'>{bookingDetails.submittedBy.name || '--'}</td>
									<th scope='row' className='slr-print-sub-label-cell'>EMAIL</th>
									<td className='slr-print-sub-value-cell'>{bookingDetails.submittedBy.email || '--'}</td>
								</tr>
								<tr className='slr-print-tabular-row'>
									<th scope='row' className='slr-print-sub-label-cell'>TELEPHONE</th>
									<td className='slr-print-sub-value-cell' colSpan={3}>{bookingDetails.submittedBy.phoneNumber || '--'}</td>
								</tr>
							</tbody>
						</table>
					</div>
				)}

				{isEnterpriseOrGsa && (
					<div className='slr-print-section'>
						<div className='slr-print-section-title'>SKY PALLET RESPONSE</div>
						{hasSkyPalletDetails ? (
						<>
						<div className='slr-print-grid slr-print-grid--skypallet'>
							<div className='slr-print-field'>
								<span className='slr-print-label'>STATUS</span>
								<span className='slr-print-value'>
									{{
										LOADABLE: 'Loadable',
										SPECIAL_LOAD: 'Special Loadable',
										NOT_LOADABLE: 'Not Loadable',
									}[bookingDetails.skyPalletDetails.loadableStatus || bookingDetails.skyPalletDetails.loadable] || bookingDetails.skyPalletDetails.loadableStatus || bookingDetails.skyPalletDetails.loadable || '--'}
								</span>
							</div>
							{bookingDetails.skyPalletDetails.adjustedWeight != null && (
								<div className='slr-print-field'>
									<span className='slr-print-label'>ADJUSTED WEIGHT</span>
									<span className='slr-print-value'>{bookingDetails.skyPalletDetails.adjustedWeight} Kg</span>
								</div>
							)}
							{bookingDetails.skyPalletDetails.loadableVolume != null && (
								<div className='slr-print-field'>
									<span className='slr-print-label'>LOADABLE VOLUME</span>
									<span className='slr-print-value'>{bookingDetails.skyPalletDetails.loadableVolume} CBM</span>
								</div>
							)}
						</div>
						{bookingDetails.skyPalletDetails.ulds?.length > 0 && (
							<div className='slr-print-sub-section'>
								<div className='slr-print-sub-title'>ULD POSITIONS</div>
								<table className='slr-print-tabular slr-print-tabular--positions' aria-label='ULD Positions'>
									<thead className='slr-print-tabular-header'>
										<tr className='slr-print-tabular-row'>
											<th scope='col' className='slr-print-tabular-cell'>POSITION</th>
											<th scope='col' className='slr-print-tabular-cell'>COUNT</th>
										</tr>
									</thead>
									<tbody>
									{bookingDetails.skyPalletDetails.ulds.map((uld, index) => (
										<tr className='slr-print-tabular-row' key={index}>
											<td className='slr-print-tabular-cell'>{uld.uld || '-'}</td>
											<td className='slr-print-tabular-cell'>{uld.uldCount ?? '-'}</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
						)}
						</>
						) : (
							<div className='slr-print-grid'>
								<div className='slr-print-field slr-print-field--full'>
									<span className='slr-print-value'>Not yet received.</span>
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	)
})

export default SlrPrintTemplate
